export namespace Util {

    // CMSサイトの本番URL
    const prodHost = "nextlio.delious.net";

    // DeliousトップページのURL
    export function deliouTopPageUrl(): string {
        const resourceName = Util.getUrlParam("head_id");
        const url = getDeliousHostUrl() + resourceName + "/menu2/home_new.php?login=true";
        return url;
    }

    // 本番モードかの判定
    export function isProduction(): boolean {
        return location.host == prodHost;
    }

    // Delious の URL
    export function getDeliousHostUrl(): string {
        return isProduction() ? "https://delious.net/" : "https://stg.delious.net/";
    }

    // lio-cms-api の URL
    export function getCmsApiHostUrl(): string {
        var host = "http://localhost:8000";
        if (isProduction()) {
            // 本番環境
            host = "https://api.nextlio.delious.net";
        } else if (location.href.indexOf("localhost") < 0) {
            // ステージング環境
            host = "https://api.stg-nextlio.delious.net";
        }
        return host;
    }

    // URLパラメータのパース
    export function getUrlParam(key: string) {

        const url = window.location.href;
        const name = key.replace(/[\[\]]/g, "\\$&");
        const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) return "";
        if (!results[2]) return "" +
            "";
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }

    // オブジェクトのディープコピー
    export function deepCopy(object: any): any {
        return JSON.parse(JSON.stringify(object));
    }

    // 仮IDの算出 (Storeをローカル更新する際に使う）
    export function getTempId(list: { id: number }[]): number {
        if (!list || list.length <= 0)
            return 0;

        if (list.filter(v => v.id == null).length > 0)
            return 0;

        const tempId = list.map(v => v.id).reduce((a, b) => Math.max(a, b)) + 1
        return tempId;
    }

    // 正規表現のメタ文字をエスケープ
    export function regExpEscape(searchWord: string): string {
        const searchValue  = /[-\/\\^$*+?.()[\]{}|]/g;
        const replaceValue = '\\$&';

        return searchWord.replace(searchValue, replaceValue);
    }
}

